import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { Box, Stack } from '@mui/material';
import DashboardComponentOption from './DashboardComponentOption';
import { DashboardObjectWidgetDto } from 'src/models/account';

interface ComponentListProps {
  components: DashboardObjectWidgetDto[];
}

const ComponentList = ({ components }: ComponentListProps) => {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden', height: '900px', paddingBlock: '20px', marginTop: '20px' }}>
      <VigoTypography value="Dashboard Components" />
      <PerfectScrollbar options={{ wheelPropagation: false }}>
        <Stack direction="column" gap={5} sx={{ alignItems: 'center', paddingBlock: '15px', overflow: 'hidden' }}>
          {components.map(option => (
            <DashboardComponentOption key={JSON.stringify(option)} component={option} />
          ))}
        </Stack>
      </PerfectScrollbar>
    </Box>
  );
};

export default ComponentList;
